import {style} from 'typestyle'
import * as csstips from 'csstips'

export const main = style({
    width: '100%',
    height: '100%',
    maxWidth: '480px',
    minWidth: '320px',
    minHeight: '100vh',
    position: 'relative',
    background: '#F4F4F4'
})

export const nothingWrap = style({
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
})

export const nothingBox = style({
    width: '100%',
    height: '100%',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    flexDirection: 'column'
})

export const nothingImg = style({
    width: '100%',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    $nest: {
        '& img': {
            width: '40%'
        }
    }
})

export const nothingTitle = style({
    fontSize: 16,
    fontWeight: 500,
    color: 'rgba(102,102,102,1)',
    lineHeight: '16px',
    marginBottom: 10,
    textAlign: 'center'
})

export const nothingSubTitle = style({
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(153,153,153,1)',
    lineHeight: '14px',
    marginBottom: 42,
    textAlign: 'center'
})

export const nothingButton = style({
    width: '100%',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center
})

export const nothingButtonText = style({
    width: '68vw',
    maxWidth: 326.4,
    height: 44,
    background: '#FF5A31',
    borderRadius: 22,
    fontSize: 16,
    fontWeight: 400,
    color: 'rgba(255,255,255,1)',
    lineHeight: '16px',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    $nest: {
        '&:active': {
            backgroundColor: '#E4431B'
        }
    }
})

export const punchCouponWrap = style({
    width: '100%',
    height: '100%',
    padding: '0 15px',
    marginBottom: 6
})

export const usedAwards = style({
    height: 48,
    fontSize: 20,
    color: '#333333',
    letterSpacing: 0,
    paddingLeft: 15,
    ...csstips.flexRoot,
    ...csstips.startJustified,
    ...csstips.center,
    fontWeight: 600,
    paddingTop: 13,
    $nest: {
        '@media (min-width: 480px)': {
            marginLeft: 2
        }
    }
})

export const convertLectureListBox = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    height: '100%',
    width: '100%',
    cursor: 'pointer',
    padding: '0 15px',
    marginBottom: 20,
    $nest: {
        '@media (max-width: 320px)': {
            padding: '0 10px'
        }
    }
})

export const convertLectureListItem = style({
    width: '100%',
    padding: '15px',
    backgroundColor: '#ffffff',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    WebkitBoxOrient: 'horizontal',
    WebkitBoxDirection: 'normal',
    flexDirection: 'row',
    position: 'relative',
    overflow: 'hidden',
    maxHeight: 120,
    borderRadius: 10,
    $nest: {
        '&::before': {
            'content': `""`,
            'position': 'absolute',
            'top': 0,
            'width': 'calc(100vw - 10px)',
            'max-width': '470px',
            'border-top': '0 solid #f0f0f0',
            'transform-origin': '100% 0',
            'transform': 'scaleY(.5)'
        }
    }
})

export const currentItemLeftBox = style({
    ...csstips.flexRoot,
    ...csstips.startJustified,
    ...csstips.center,
    ...csstips.vertical,
    height: 90
})

export const currentItemLeft = style({
    marginRight: 10,
    width: 120,
    height: 68,
    position: 'relative',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
})

export const currentItemImg = style({
    width: 120,
    height: 68,
    position: 'relative',
    overflow: 'hidden',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
})

export const currentItemRight = style({
    width: 'calc(100% - 130px)',
    ...csstips.flexRoot,
    ...csstips.startJustified,
    ...csstips.start,
    WebkitBoxOrient: 'vertical',
    WebkitBoxDirection: 'normal',
    WebkitBoxPack: 'justify',
    height: 90
})

export const currentItemRightTitle = style({
    'fontSize': 14,
    'color': '#333333',
    'textOverflow': 'ellipsis',
    'display': '-webkit-box',
    '-webkit-line-clamp': 2,
    'WebkitBoxOrient': 'vertical',
    'fontWeight': 400,
    'overflow': 'hidden',
    'lineHeight': '22px',
    'wordBreak': 'break-all',
    'letterSpacing': 0,
    'marginTop': '-2px'
})

export const periodsNumber = style({
    position: 'absolute',
    bottom: 15,
    left: 145,
    fontSize: 12,
    fontWeight: 400,
    color: '#999999',
    lineHeight: '12px',
    marginBottom: 5
})

export const currentItemRightContainer = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    margin: 0,
    padding: 0,
    position: 'absolute',
    width: '25.6vw',
    maxWidth: 122,
    height: 36,
    backgroundColor: '#FF5A31',
    borderRadius: 20,
    top: 69,
    right: 15,
    fontSize: 16,
    boxShadow: '0 1px 5px 0 rgba(255,90,49,0.40)',
    cursor: 'pointer',
    $nest: {
        '&:active': {
            backgroundColor: '#E4431B'
        },
        '@media (max-width: 320px)': {
            right: 10
        }
    }
})

export const currentItemRightMiddle = style({
    lineHeight: 1,
    color: '#ffffff',
    marginBottom: 10
})

export const currentItemRightBottom = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    fontSize: 14,
    color: '#FFFFFF',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '14px'
})

export const currentItemRightBottomLeftContent = style({
    width: 120,
    height: 22,
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.centerJustified,
    position: 'relative',
    background: '#F4F4F4',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    fontSize: 12,
    color: '#999999',
    letterSpacing: 0,
    lineHeight: '12px',
    fontWeight: 400,
    $nest: {
        '& img': {
            width: 10,
            marginRight: 5
        }
    }
})

export const studyNum = style({
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.centerJustified,
    marginLeft: 1
})



// WEBPACK FOOTER //
// ./src/views/Punch/MyPunchCoupon/MyPunchCoupon.style.ts